var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
export var TypeActionCoopInfo;
(function (TypeActionCoopInfo) {
    TypeActionCoopInfo["Received"] = "CoopInfo > Received";
    TypeActionCoopInfo["SetProjectAccessTime"] = "CoopInfo > SetProjectAccessTime";
    TypeActionCoopInfo["LeaveCoop"] = "CoopInfo > LeaveCoop";
    TypeActionCoopInfo["LeaveCoopSuccessfully"] = "CoopInfo > LeaveCoopSuccessfully";
    TypeActionCoopInfo["SearchRequest"] = "Coop > SearchRequest";
    TypeActionCoopInfo["SearchResponse"] = "Coop > SearchResponse";
    TypeActionCoopInfo["JoinableCoopList"] = "Coop > JoinableCoopList";
    TypeActionCoopInfo["JoinableCoopListResponse"] = "Coop > JoinableCoopListResponse";
    TypeActionCoopInfo["SetFilterLanguage"] = "Coop > SetFilterLanguage";
    TypeActionCoopInfo["ClearSelectedCoop"] = "Coop > ClearSelectedCoop";
    TypeActionCoopInfo["SetFoundLanguage"] = "Coop > SetFoundLanguage";
    TypeActionCoopInfo["FoundCoop"] = "Coop > FoundCoop";
    TypeActionCoopInfo["EditCoop"] = "Coop > EditCoop";
    TypeActionCoopInfo["EditCoopSuccess"] = "Coop > EditCoopSuccess";
    TypeActionCoopInfo["UpdateCoopMessage"] = "Coop > UpdateMessage";
    TypeActionCoopInfo["GetCoopEventNotices"] = "Coop > GetEventNotices";
    TypeActionCoopInfo["GetCoopEventNoticesResponse"] = "Coop > GetEventNoticesResponse";
    TypeActionCoopInfo["InvitePlayer"] = "CoopInfo > InvitePlayer";
    TypeActionCoopInfo["InvitePlayerResponse"] = "CoopInfo > InvitePlayerResponse";
    TypeActionCoopInfo["ClearInvitePlayerResponse"] = "CoopInfo > ClearInvitePlayerResponse";
    TypeActionCoopInfo["InviteInfoReceived"] = "CoopInfo > InviteInfoReceived";
    TypeActionCoopInfo["InviteInfoUpdate"] = "CoopInfo > InviteInfoUpdate";
    TypeActionCoopInfo["JoinCoop"] = "CoopInfo > JoinCoop";
    TypeActionCoopInfo["PlayerCancelInvite"] = "CoopInfo > PlayerCancelInvite";
    TypeActionCoopInfo["MemberRequest"] = "CoopInfo > MemberRequest";
    TypeActionCoopInfo["MemberResponse"] = "CoopInfo > MemberResponse";
    TypeActionCoopInfo["JoinableCoopSelect"] = "CoopInfo > JoinableCoopSelect";
    TypeActionCoopInfo["TabGoTo"] = "CoopInfo > TabGoTo";
    TypeActionCoopInfo["CoopHudClicked"] = "CoopInfo > CoopHudClicked";
    TypeActionCoopInfo["KickMember"] = "CoopInfo > KickMember";
    TypeActionCoopInfo["KickMemberResponse"] = "CoopInfo > KickMemberResponse";
    TypeActionCoopInfo["CollectCoopPoints"] = "CoopInfo > CollectCoopPoints";
    TypeActionCoopInfo["CollectCoopPointsResponse"] = "CoopInfo > CollectCoopPointsResponse";
    TypeActionCoopInfo["CoopPointsInfoRequest"] = "CoopInfo > CoopPointsInfoRequest";
    TypeActionCoopInfo["CoopPointsInfoResponse"] = "CoopInfo > CoopPointsInfoResponse";
    TypeActionCoopInfo["SendCoopPoints"] = "CoopInfo > SendCoopPoints";
    TypeActionCoopInfo["SendCoopPointsResponse"] = "CoopInfo > SendCoopPointsResponse";
    TypeActionCoopInfo["AssignRole"] = "CoopInfo > AssignRole";
    TypeActionCoopInfo["AssignRoleResponse"] = "CoopInfo > AssignRoleResponse";
    TypeActionCoopInfo["ResetProject"] = "CoopInfo > ResetContributions";
    TypeActionCoopInfo["SelectCoopProjectType"] = "CoopProjects > SelectType";
    TypeActionCoopInfo["SelectCoopProjectDifficulty"] = "CoopProjects > SelectDifficulty";
    TypeActionCoopInfo["StartCoopProject"] = "CoopProjects > Start";
    TypeActionCoopInfo["StartCoopProjectSuccess"] = "CoopProjects > Start > Success";
    TypeActionCoopInfo["StopCoopProject"] = "CoopProjects > Stop";
    TypeActionCoopInfo["StopCoopProjectSuccess"] = "CoopProjects > Stop > Success";
    TypeActionCoopInfo["CoopProjectUpdate"] = "CoopProjects > Update";
    TypeActionCoopInfo["ProjectInfoRequest"] = "CoopProjects > ProjectInfoRequest";
    TypeActionCoopInfo["ProjectInfoResponse"] = "CoopProjects > ProjectInfoResponse";
    TypeActionCoopInfo["ProjectInfoClear"] = "CoopProjects > ProjectInfoClear";
    TypeActionCoopInfo["ProjectInfoReceived"] = "CoopProjects > ProjectInfoReceived";
    TypeActionCoopInfo["RequestCoopProjectTypeInfo"] = "CoopProjects > RequestCoopProjectTypeInfo";
    TypeActionCoopInfo["RequestCoopProjectTypeInfoSuccess"] = "CoopProjects > RequestCoopProjectTypeInfo > Success";
    TypeActionCoopInfo["AddXp"] = "CoopInfo > AddXp";
    TypeActionCoopInfo["AddSearchCoopMembers"] = "CoopInfo > AddSearchCoopMembers";
    TypeActionCoopInfo["CoopBuffInfoReceived"] = "CoopInfo > CoopBuffInfoReceived";
    TypeActionCoopInfo["SetFirstTab"] = "SetFirstTab";
})(TypeActionCoopInfo || (TypeActionCoopInfo = {}));
export var actionCoopInfoReceived = function (props) { return (__assign({}, props, { type: TypeActionCoopInfo.Received })); };
export var actionCoopAddSearchCoopMembers = function (member) { return ({
    member: member,
    type: TypeActionCoopInfo.AddSearchCoopMembers,
}); };
export var actionCoopInfoSetProjectAccessTime = function (time) {
    if (time === void 0) { time = 0; }
    return ({
        time: time,
        type: TypeActionCoopInfo.SetProjectAccessTime,
    });
};
export var actionCoopInfoLeaveCoop = function () { return ({
    type: TypeActionCoopInfo.LeaveCoop,
}); };
export var actionCoopInfoLeaveCoopSuccessfully = function () { return ({
    type: TypeActionCoopInfo.LeaveCoopSuccessfully,
}); };
export var actionCoopInfoInviteInfoReceived = function (props) { return (__assign({}, props, { type: TypeActionCoopInfo.InviteInfoReceived })); };
export var actionCoopInfoInviteInfoUpdate = function () { return ({
    type: TypeActionCoopInfo.InviteInfoUpdate,
}); };
export var actionCoopInfoJoinCoop = function (props) { return (__assign({}, props, { type: TypeActionCoopInfo.JoinCoop })); };
export var actionCoopInfoInvitePlayer = function (playerId, coopId, playerIdToInvite) { return ({
    coopId: coopId,
    playerId: playerId,
    playerIdToInvite: playerIdToInvite,
    type: TypeActionCoopInfo.InvitePlayer,
}); };
export var actionCoopInfoInvitePlayerResponse = function (props) { return (__assign({}, props, { type: TypeActionCoopInfo.InvitePlayerResponse })); };
export var actionCoopInfoClearInvitePlayerResponse = function () { return ({
    type: TypeActionCoopInfo.ClearInvitePlayerResponse,
}); };
export var actionCoopInfoPlayerCancelInvite = function () { return ({
    type: TypeActionCoopInfo.PlayerCancelInvite,
}); };
export var actionCoopInfoResetProject = function () { return ({
    type: TypeActionCoopInfo.ResetProject,
}); };
export var actionCoopSearchRequest = function (props) { return (__assign({}, props, { type: TypeActionCoopInfo.SearchRequest })); };
export var actionJoinableCoopSelect = function (coop, member) { return ({
    coop: coop,
    member: member,
    type: TypeActionCoopInfo.JoinableCoopSelect,
}); };
export var actionCoopSearchResponse = function (props) { return (__assign({}, props, { type: TypeActionCoopInfo.SearchResponse })); };
export var actionCoopJoinableCoopList = function (props) { return (__assign({}, props, { type: TypeActionCoopInfo.JoinableCoopList })); };
export var actionCoopJoinableCoopListResponse = function (props) { return (__assign({}, props, { type: TypeActionCoopInfo.JoinableCoopListResponse })); };
export var actionCoopSetFilterLanguageSelected = function (language) { return ({
    language: language,
    type: TypeActionCoopInfo.SetFilterLanguage,
}); };
export var actionCoopSetFoundLanguageSelected = function (language) { return ({
    language: language,
    type: TypeActionCoopInfo.SetFoundLanguage,
}); };
export var actionCoopClearSelectedCoop = function () { return ({
    type: TypeActionCoopInfo.ClearSelectedCoop,
}); };
export var actionCoopFoundCoop = function (description, joinPolicy, language, minLevel, name) { return ({
    description: description,
    joinPolicy: joinPolicy,
    language: language,
    minLevel: minLevel,
    name: name,
    type: TypeActionCoopInfo.FoundCoop,
}); };
export var actionCoopEditCoop = function (description, joinPolicy, language, minLevel, coopId) { return ({
    coopId: coopId,
    description: description,
    joinPolicy: joinPolicy,
    language: language,
    minLevel: minLevel,
    type: TypeActionCoopInfo.EditCoop,
}); };
export var actionCoopEditCoopSuccess = function (coop, project) { return ({
    coop: coop,
    project: project,
    type: TypeActionCoopInfo.EditCoopSuccess,
}); };
export var actionUpdateCoopMessage = function (message) { return ({
    message: message,
    type: TypeActionCoopInfo.UpdateCoopMessage,
}); };
export var actionGetCoopEventNotices = function () { return ({
    type: TypeActionCoopInfo.GetCoopEventNotices,
}); };
export var actionGetCoopEventNoticesResponse = function (messageParams) { return ({
    messageParams: messageParams,
    type: TypeActionCoopInfo.GetCoopEventNoticesResponse,
}); };
export var actionCoopMemberRequest = function (playerId, coopId) { return ({
    coopId: coopId,
    playerId: playerId,
    type: TypeActionCoopInfo.MemberRequest,
}); };
export var actionCoopMemberResponse = function (coop, member, tabId) { return ({
    coop: coop,
    member: member,
    tabId: tabId,
    type: TypeActionCoopInfo.MemberResponse,
}); };
export var actionCoopMenuTabGoTo = function (tabId) { return ({
    tabId: tabId,
    type: TypeActionCoopInfo.TabGoTo,
}); };
export var actionCoopHudClicked = function () { return ({
    type: TypeActionCoopInfo.CoopHudClicked,
}); };
export var actionCoopInfoKickMember = function (playerId, coopId, playerIdToKick) { return ({
    coopId: coopId,
    playerId: playerId,
    playerIdToKick: playerIdToKick,
    type: TypeActionCoopInfo.KickMember,
}); };
export var actionCoopInfoKickMemberResponse = function (props) { return (__assign({}, props, { type: TypeActionCoopInfo.KickMemberResponse })); };
export var actionCoopAssignMemberRole = function (playerId, coopId, playerIdToAssign, roleId) { return ({
    coopId: coopId,
    playerId: playerId,
    playerIdToAssign: playerIdToAssign,
    roleId: roleId,
    type: TypeActionCoopInfo.AssignRole,
}); };
export var actionCoopAssignMemberRoleResponse = function (props) { return (__assign({}, props, { type: TypeActionCoopInfo.AssignRoleResponse })); };
export var actionCoopPointsInfoRequest = function (playerId, coopId) { return ({
    coopId: coopId,
    playerId: playerId,
    type: TypeActionCoopInfo.CoopPointsInfoRequest,
}); };
export var actionCoopPointsInfoResponse = function (props) { return (__assign({}, props, { type: TypeActionCoopInfo.CoopPointsInfoResponse })); };
export var actionCoopSendPoints = function (playerId, coopId) { return ({
    coopId: coopId,
    playerId: playerId,
    type: TypeActionCoopInfo.SendCoopPoints,
}); };
export var actionCoopSendPointsResponse = function (props) { return (__assign({}, props, { type: TypeActionCoopInfo.SendCoopPointsResponse })); };
export var actionCoopCollectPoints = function (playerId, coopId) { return ({
    coopId: coopId,
    playerId: playerId,
    type: TypeActionCoopInfo.CollectCoopPoints,
}); };
export var actionCoopCollectPointsResponse = function () { return ({
    type: TypeActionCoopInfo.CollectCoopPointsResponse,
}); };
export var actionCoopProjectSelected = function (coopProjectTypeId) { return ({
    coopProjectTypeId: coopProjectTypeId,
    type: TypeActionCoopInfo.SelectCoopProjectType,
}); };
export var actionCoopProjectDifficultySelected = function (difficultyLevel) { return ({
    difficultyLevel: difficultyLevel,
    type: TypeActionCoopInfo.SelectCoopProjectDifficulty,
}); };
export var actionCoopProjectStart = function (coopProjectId, difficulty) { return ({
    coopProjectId: coopProjectId,
    difficulty: difficulty,
    type: TypeActionCoopInfo.StartCoopProject,
}); };
export var actionCoopProjectStartSuccess = function (props) { return (__assign({}, props, { type: TypeActionCoopInfo.StartCoopProjectSuccess })); };
export var actionCoopProjectStop = function (coopProjectId) { return ({
    coopProjectId: coopProjectId,
    type: TypeActionCoopInfo.StopCoopProject,
}); };
export var actionCoopProjectStopSuccess = function (props) { return (__assign({}, props, { type: TypeActionCoopInfo.StopCoopProjectSuccess })); };
export var actionCoopProjectTypeInfoRequest = function (coopId, playerId) { return ({
    coopId: coopId,
    playerId: playerId,
    type: TypeActionCoopInfo.RequestCoopProjectTypeInfo,
}); };
export var actionCoopProjectTypeInfoResponse = function (props) { return (__assign({}, props, { projectTypeInfo: props.type, type: TypeActionCoopInfo.RequestCoopProjectTypeInfoSuccess })); };
export var actionCoopProjectInfoReceived = function (props) { return (__assign({}, props, { type: TypeActionCoopInfo.ProjectInfoReceived })); };
export var actionCoopProjectInfoRequest = function (props) { return (__assign({}, props, { type: TypeActionCoopInfo.ProjectInfoRequest })); };
export var actionCoopProjectInfoResponse = function (props) { return (__assign({}, props, { type: TypeActionCoopInfo.ProjectInfoResponse })); };
export var actionCoopBuffInfoResponse = function (props) { return (__assign({}, props, { type: TypeActionCoopInfo.CoopBuffInfoReceived })); };
export var actionCoopProjectInfoClear = function () { return ({
    type: TypeActionCoopInfo.ProjectInfoClear,
}); };
export var actionCoopInfoAddXp = function (xp) { return ({
    type: TypeActionCoopInfo.AddXp,
    xp: xp,
}); };
export var actionCoopMenuSetFirstTab = function (tabId) { return ({
    tabId: tabId,
    type: TypeActionCoopInfo.SetFirstTab,
}); };



//////////////////
// WEBPACK FOOTER
// ./src/features/cooperative/actionCoop.ts
// module id = 24
// module chunks = 3